import React__default from 'react';
import { useFramesEcommContext } from '../../context/FramesEcommContext.js';
import { OfferingsListContainer } from '../../../components/OfferingsList/OfferingsListContainer.js';

const FramesOfferingsList = ()=>{
    const { offerings , selectedOffering , setSelectedOffering  } = useFramesEcommContext();
    if (!selectedOffering) return null;
    return /*#__PURE__*/ React__default.createElement(OfferingsListContainer, {
        offerings: offerings,
        selectedValue: selectedOffering,
        onChange: setSelectedOffering
    });
};

export { FramesOfferingsList };
//# sourceMappingURL=FramesOfferingsList.js.map
